export default __webpack_public_path__ + "static/media/research-bio.2160e994.jpg";